import { useState, useEffect, Suspense } from 'react';
import { NavLink } from "react-router-dom";
import "bootstrap";
import { Googlelogin, Microsoftlogin } from "./../custom_functions/Thirdpartylogins.jsx";
import {
    Servicecalls,
    convertUTCDateToLocalDate
} from "./../custom_functions/Functions.jsx";
import {
    countrieslist,
    isMultitenant
} from "./../custom_functions/Constance.jsx";
import { withTranslation } from 'react-multi-lang';
import { withAlert } from 'react-alert';
import PageLoader from './general/PageLoader.jsx';
import KendoCombobox from '../controls/KendoCombobox.jsx';
const ELNurl = window.appUrl.ELN;

function Register(props) {
    // const [key, setKey] = useState('home');
    const [activeTab, setActiveTab] = useState('v-pills-home'); // Set default active tab
    const [accountselect, setAccountselect] = useState(1);
    const [step, setStep] = useState(0);
    const [teamsize, setTeamsize] = useState(1);
    const [organisation, setOrganisation] = useState('');
    const [designation, setdesignation] = useState('');
    // const [country, setCountry] = useState('');
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [usernameError, setUsernameError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectededulevel,setSelectedEdulevel] =useState([])
    const [ispasswordvalid, setIspasswordvalid] = useState("");
    const [password, setPassword] = useState("");
    const [confirmpassword, setConfirmpassword] = useState("");
    const [isconfirmpasswordvalid, setIsconfirmpasswordvalid] = useState("");
    // const [isconfirmpassword, setIsconfirmpassword] = useState(false);
    const [edulevel, setEdulevel] = useState(
          [
            {
              type: 0,
              name: props.t("Bachelors Degree", {
                param: "",
              }),
            },
            {
              type: 1,
              name: props.t("Masters Degree", {
                param: "",
              }),
            },
            {
              type: 2,
              name: props.t("Post Doctorate", {
                param: "",
              }),
            },           
          ]
    )
    // const [captchaText, setCaptchaText] = useState(generateCaptcha());
    // const [userInput, setUserInput] = useState('');
    // const [captchaError, setCaptchaError] = useState('');
    const [registereddate, setRegistereddate] = useState(new Date());
    const [autenticate_from, setAutenticatefrom] = useState(Number);
    const [IsLoader,setIsLoader] = useState(false);

    useEffect(() => {
                setCountries(countrieslist);
    }, []);

    const handleTeamsizeChange = (e) => {
        const inputValue = e.target.value;    
        // Check if the input is empty or matches the desired format (two digits)
        if (inputValue === '' || (inputValue >= 1 && inputValue <= 10)) {
            setTeamsize(inputValue);
        }
      };
      const handleEduChange = (obj) => {
        setSelectedEdulevel( obj === null ? [] :[obj]);      
      }
    const handleTabClick = (tabId) => {
        // setActiveTab(tabId);
    };

    const userSelectedCountry = (country) => {
        setSelectedCountry(country);
    }

    const onthirdpartyautenticated = (userdata) => {
        registeruser(userdata);
    }

    const onuserlogin = (e) => {
        let validate = true
        if(isUsernameValid(username)){
        // Validate username
        if (!username || username === "") {
            setUsernameError('Please enter a valid username');
            return;
        }

        if (password === "") { 
            setIspasswordvalid('Please enter a valid password'); 
            props.alert.error("Enter password");
             validate = false; return; 
            }else if(password.length >=5) { 
                setIspasswordvalid("") 
            }else{
                props.alert.error("Password length must be within five characters ");
                setIspasswordvalid("invalid");
                validate = false; return; 
            }
        if (confirmpassword === "") { 
            setIsconfirmpasswordvalid('Please enter a valid confirm password'); 
            props.alert.error("Enter confirm password"); 
            validate = false; return;
            } else if(password.length >=5) {
                setIsconfirmpasswordvalid(""); 
            }else{
                props.alert.error(" Password length must be within five characters "); 
                setIsconfirmpasswordvalid("invalid");
                validate = false; return; 
            }
        if (password !== confirmpassword) {
            setIsconfirmpasswordvalid('Password mismatch between password and confirm password')
            props.alert.error("Password mismatch between password and confirm password");
            return;
        }        
        if (!validate) return;
        // Validate email
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!email || !emailRegex.test(email)) {
            setEmailError('Please enter a valid email address');
            props.alert.error("Please enter a valid email id");
            return;
        }

        // Validate CAPTCHA
        // if (userInput !== captchaText) {
        //     setCaptchaError('Incorrect CAPTCHA text. Please try again.');
        //     return;
        // }

        let userdata = {
            username: username,
            userfullname: username,
            emailid: email,
            autenticatefrom: 0,
            lockcount: 0,
            loginfrom: 0,
            userstatus: "A",
            userretirestatus: 0,
            passwordstatus: 0,
            password: password
        }
        if(emailError === "" && usernameError === "" && ispasswordvalid === "" && isconfirmpasswordvalid === ""){
            registeruser(userdata);
        }else if(emailError !== "" && usernameError !== "")  {
            props.alert.error("Username and email id Exist")
        }else if( usernameError !== ""){
            props.alert.error("Username Exist");
        }else if(ispasswordvalid !== ""){
            props.alert.error("Enter password");
        }else if(isconfirmpasswordvalid !== ""){
            props.alert.error("Enter confirm password");
        }else if(emailError !== ""){
            props.alert.error("Email id Exist");
        }      
    }else{
        setUsernameError('Invalid username');
    }
    };

    const registeruser = (userdata) => {
        setIsLoader(true);
        let sitedetails = {
            sitename: organisation,
            teamsize: teamsize, accouttype: accountselect,
            organisationname: organisation, country: selectedCountry,
            istatus: 1
        };
        userdata.lssitemaster = sitedetails;
        userdata.ismultitenant = isMultitenant;
        userdata.multitenantusercount = teamsize;
        userdata.userloginlink = window?.location?.origin;
        userdata.designationname=designation;
        userdata.edulevel = selectededulevel.length === 0 ? "" : selectededulevel[0].name;

        Servicecalls("" + ELNurl + "/Freeuserlogin/Createuser", userdata, (response) => {
            setIsLoader(false);  
            console.log(response);
            if (response.objResponse.status) {
                setAutenticatefrom(response.autenticatefrom); 
                setActiveTab("v-pills-messages");
                setStep(4);
                setRegistereddate(new Date(convertUTCDateToLocalDate(response.createddate))) 
                          
            }else{
              props.alert.error(props.t(response.objResponse.information))  
            }     
        }, () => { });
    }

    const isUsernameValid = (name) => {
        // const usernamePattern = /^[a-zA-Z0-9]{3,}$/;
        // return usernamePattern.test(username);

        const containsLetterRegex = /^(?=(?:[^a-zA-Z]*[a-zA-Z]){3})[\w\W]+$/;
        // If the input contains no letters, return false
        if (!containsLetterRegex.test(name)) {
          props.alert.error("USERNAME MUST CONTAIN ATLEAST 3 LETTERS");
          return false;
        }
        return true;
    };

    const isEmailValid = (mail) => {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(mail);
    };

    const handleUsernameChange = (e) => {
        const newUsername = e.target.value;
        setUsername(newUsername);
        if (e.target.value.trim() !== "") {
            let userdata = { username: e.target.value, autenticatefrom: 0 }
            Servicecalls("" + ELNurl + "/Freeuserlogin/Validateuser", userdata, (response) => {
                if (response && !response.username) {
                    setUsernameError('');
                } else {
                    setUsernameError('Invalid username'); 
                }
            }, () => { });
        } else{
            setUsernameError('');
        }
    };
    const onpasswordchange = (e) => {
        setPassword(e.target.value);
        if(Number(e.target.value.length) >=5){
            setIspasswordvalid("");
        }else{
            setIspasswordvalid("password min four char");
        }
    }
    const onconfirmpasswordchange = (e) => {
        setConfirmpassword(e.target.value);
        if (password === e.target.value && Number(e.target.value.length) >=5) {
            setIsconfirmpasswordvalid("");
        }else{
            setIsconfirmpasswordvalid("invalid")
        }            
    }

    const handleEmailChange = (event) => {
        const newEmail = event.target.value;
        setEmail(newEmail);
        
        if(isEmailValid(newEmail)){
        let userdata = { username: username, emailid:newEmail , autenticatefrom: 0}            
            Servicecalls("" + ELNurl + "/Freeuserlogin/ValidateEmail", userdata,
                (response) => {
                console.log(response);
                if(response.objResponse.status === true && response.objResponse.information === "User present"){
                    setEmailError('Invalid email address');              
                }else {
                    setEmailError('');
                }
             },
            () => { });

        }else{
            setEmailError('Invalid email address'); 
        }
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (isUsernameValid(username) && isEmailValid()) {
            console.log('Form submitted successfully');
        } else {
            console.log('Form contains validation errors. Please fix them.');
        }
    };

    // function generateCaptcha() {
    //     // Implement your logic to generate a random text for the CAPTCHA
    //     const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+';
    //     let captcha = '';
    //     for (let i = 0; i < 8; i++) {
    //         const randomIndex = Math.floor(Math.random() * characters.length);
    //         captcha += characters[randomIndex];
    //     }
    //     return captcha;
    // }

    // const handleUserInputChange = (e) => {
    //     setUserInput(e.target.value);
    //     setCaptchaError(''); // Clear any previous error when the user types
    // };

    //   const handleCaptchaSubmit = () => {
    //     // Validate the user input against the generated CAPTCHA text
    //     if (userInput.toUpperCase() === captchaText) {
    //       // The CAPTCHA is correct, handle success
    //       console.log('CAPTCHA is correct!');
    //     } else {
    //       // The CAPTCHA is incorrect, handle error
    //       setCaptchaError('Incorrect CAPTCHA text. Please try again.');
    //       // Generate a new CAPTCHA to refresh
    //       setCaptchaText(generateCaptcha());
    //     }
    //   };

    // const handleReloadCaptcha = () => {
    //     // Reload or regenerate the CAPTCHA text
    //     setCaptchaText(generateCaptcha());
    //     setUserInput('');
    //     setCaptchaError('');
    // };



    return (
        <div>
            <div className='row d-flex align-items-start m-0 register_page' style={{ height: "100vh" }}>
                <div className='col-5 bg-logo-color' >
                    <div className='logo'>
                        <img src='../images/eln_lite_white_logo.svg' alt='' />
                    </div>
                    <div className='nav flex-column nav-pills' id="v-pills-tab" role="tablist" aria-orientation="vertical">
                        <button className={`nav-link ${step >= 1 ? "completed" : ""} ${activeTab === 'v-pills-home' ? 'active' : ''}`}
                            onClick={() => handleTabClick('v-pills-home')}
                            id="v-pills-home-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#v-pills-home"
                            type="button"
                            role="tab"
                            aria-controls="v-pills-home"
                            aria-selected={activeTab === 'v-pills-home'}>Account Type</button>
                        <button className={`nav-link ${step >= 2 ? "completed" : ""} ${activeTab === 'v-pills-profile' ? 'active' : ''}`}
                            onClick={() => handleTabClick('v-pills-profile')}
                            id="v-pills-profile-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#v-pills-profile"
                            type="button"
                            role="tab"
                            aria-controls="v-pills-profile"
                            aria-selected={activeTab === 'v-pills-profile'}>Account Info</button>
                        <button className={`nav-link ${step >= 3 ? "completed" : ""} ${activeTab === 'v-pills-register' ? 'active' : ''}`}
                            onClick={() => handleTabClick('v-pills-register')}
                            id="v-pills-register-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#v-pills-register"
                            type="button"
                            role="tab"
                            aria-controls="v-pills-register"
                            aria-selected={activeTab === 'v-pills-register'}>Register</button>
                        <button className={`nav-link ${step >= 4 ? "completed" : ""} ${activeTab === 'v-pills-messages' ? 'active' : ''}`}
                            onClick={() => handleTabClick('v-pills-messages')}
                            id="v-pills-messages-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#v-pills-messages"
                            type="button"
                            role="tab"
                            aria-controls="v-pills-messages"
                            aria-selected={activeTab === 'v-pills-messages'}>Completed</button>
                    </div>
                    <div className='register-footer text-center'>
                        <div className="login-footer lfWeb">
                            <span className="primary-logo bottom">
                                <img
                                    src="images/Agaram-Technologies_horizontal_white.svg"
                                    alt="Agaram_eln-logo"
                                />
                            </span>
                            <div className='d-flex w-100'>
                                <p className=''>
                                    Copyright © 2024 - 2025 Agaram Technologies Pvt Ltd.
                                </p>
                                <ul className='list-inline mb-0'>
                                    <li className='list-inline-item'>
                                        <a href="https://www.agaramtech.com/about-us"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >About </a>|
                                    </li>
                                    <li className='list-inline-item'> <a
                                        href="https://www.agaramtech.com/terms-and-conditions/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Terms & Conditions
                                    </a>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>
                <div className='col-7 tab-content' >
                    <div>
                        <p className='float-right py-3'>{props.t("Login.IDS_LBL_ALREDYREGISTER")} ? <a href='/'>{props.t("Login.IDS_LBL_LOGINHERE")}</a></p>
                    </div>
                    <div className='w-100' id="v-pills-tabContent">
                        <div className={`tab-pane ${activeTab === 'v-pills-home' ? 'active' : ''}`} id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
                            <h5>{props.t("Login.IDS_LBL_CHOOSEACCUNTTYPE")}</h5>
                            <p>{props.t("Login.IDS_LBL_HELPINFO")} <a target="_blank" rel="noopener noreferrer"
                            href="https://helpcenter.agaramtech.com/">{props.t("Login.IDS_LBL_HELPPAGE")}</a></p>
                            <div className={`card ${accountselect === 1 ? 'activeaccount' : ''}`} onClick={() => { setAccountselect(1); setTeamsize(1); }}>
                                <div className='img'></div>
                                <div className="card-content">
                                    <h6 className="card-title">{props.t("Login.IDS_LBL_PERSONALACCOUNT")}</h6>
                                    <p className="card-description">{props.t("Login.IDS_LBL_ACCUNTONEUSER")} </p>
                                </div>
                            </div>
                            <div className={`card ${accountselect === 2 ? 'activeaccount' : ''}`} onClick={() => { setAccountselect(2) }}>
                                <div className='img corporate'></div>
                                <div className="card-content">
                                    <h6 className="card-title">{props.t("Login.IDS_LBL_CORPORATEACCOUNT")}</h6>
                                    <p className="card-description">{props.t("Login.IDS_LBL_ORGUSERSINFO")}  </p>
                                </div>
                            </div>
                            <div className={`card ${accountselect === 3 ? 'activeaccount' : ''}`} onClick={() => { setAccountselect(3) }}>
                                <div className='img academic'></div>
                                <div className="card-content">
                                    <h6 className="card-title">{props.t("Login.IDS_ACADEMICUSER")}</h6>
                                    <p className="card-description">{props.t("Login.IDS_ACADEMICINFO")}  </p>
                                </div>
                            </div>
                            <button className='textBtn btn_white_bg m-2 btn btn-secondary' onClick={() => { setActiveTab("v-pills-profile"); setStep(1); }}>{props.t("Login.IDS_LBL_CONTINUE")}</button>
                        </div>
                        <div className={`tab-pane ${activeTab === 'v-pills-profile' ? 'active' : ''}`} id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab">
                            <h5>{props.t("Login.IDS_LBL_ACCOUNTINFO")}</h5>
                            <p>{props.t("Login.IDS_LBL_HELPINFO")}<a target="_blank" rel="noopener noreferrer"
                            href="https://helpcenter.agaramtech.com/">{props.t("Login.IDS_LBL_HELPPAGE")}</a></p>

                            {(accountselect === 2 || accountselect === 3) && <><h5>{accountselect === 3 ? props.t("Login.IDS_LBL_ACSIZE") : props.t("Login.IDS_LBL_SIZE")}</h5>
                                <div class="form-group ">

                                    <div class="input-group mb-0">
                                        <div class="input-group-addon">
                                            <i class="organisation-icon"></i>
                                        </div>
                                        <input class="form-control" id="name" name="name" placeholder='Team Size'
                                            type="number" min={1} max={10} value={teamsize}
                                            autocomplete="off" 
                                            // onChange={(e) => {
                                            //     setTeamsize(e.target.value)
                                            // }} 
                                            onChange={handleTeamsizeChange} 
                                            />

                                    </div>
                                    <span className='d-block max-limit'>{props.t("Login.IDS_LBL_MAXIMUMOFSIZE")}</span>
                                </div></>}

                            <div class="form-group ">

                                <div class="input-group">
                                    <div class="input-group-addon">
                                        <i class="organisation-icon"></i>
                                    </div>
                                    <input class="form-control" id="name" name="name" placeholder= {accountselect === 3 ? props.t("Login.IDS_LBL_ACNAME") :'Organization Name' }
                                        autocomplete="off"
                                        type="text" value={organisation} onChange={(e) => { setOrganisation(e.target.value) }} />
                                </div>
                                {accountselect === 3 ?
                                
                                     <>
                                     <div class="input-group">
                                            <div class="input-group-addon">
                                                <i class="designation-icon"></i>
                                            </div>
                                            <Suspense fallback={<div></div>}>
                                                {/* <SelectBox                                                    
                                                    Keyvalue="key"
                                                    selClsname="form-control"
                                                    Datasource={edulevel}
                                                    ValueMember="key"
                                                    DisplayMember="value"
                                                    valuechange={handleEduChange}
                                                    value={selectededulevel}
                                                    optiondisabled={"true"} /> */}
                                                    <KendoCombobox
                                                    initialValue=""
                                                    id="id-combo-edulevel"
                                                    Datasource={edulevel}
                                                    DefaultValue={selectededulevel?.length === 0 ? "" : selectededulevel[0]}
                                                    onvaluechange={handleEduChange}
                                                    ValueMember="type"
                                                    DisplayMember="name"
                                                    Placeholder={"Level of study"} />
                                            </Suspense>
                                        </div>

                                     <div class="input-group">
                                        <div class="input-group-addon">
                                            <i class="fieldofstudy-icon"></i>
                                        </div>
                                        <input class="form-control" id="name" name="name" placeholder='Field of Study'
                                            autocomplete="off"
                                            type="text" value={designation} onChange={(e) => { setdesignation(e.target.value); } } />
                                    </div>
                                    </>


                                 :
                                 <div class="input-group">
                                 <div class="input-group-addon">
                                     <i class="designation-icon"></i>
                                 </div>
                                 <input class="form-control" id="name" name="name" placeholder='Designation'
                                     autocomplete="off"
                                     type="text" value={designation} onChange={(e) => { setdesignation(e.target.value) }} />
                                 </div>
                                }
                               
                                <div class="input-group">
                                    <div class="input-group-addon">
                                        <i class="country-icon"></i>
                                    </div>
                                    {/* <SelectBox
                                        //Keyvalue="idDomain"
                                        selClsname={
                                            "form-control form-control-sm "
                                        }
                                        Datasource={countries}
                                        ValueMember={selectedCountry}
                                        DisplayMember="common"
                                        //AttributeMember="categories"
                                        valuechange={userSelectedCountry.bind(this)}
                                    >
                                    </SelectBox> */}
                                    <KendoCombobox
                                                    initialValue=""
                                                    id="id-combo-edulevel"
                                                    Datasource={countries}
                                                    DefaultValue={selectedCountry}
                                                    onvaluechange={userSelectedCountry}
                                                    // ValueMember="type"
                                                    DisplayMember=""
                                                    Placeholder={"Country"} />
                                    {/* <input class="form-control" id="name" name="name" placeholder='Country' type="text"
                                        autocomplete="off"
                                        value={country} onChange={(e) => { setCountry(e.target.value) }} />  */}
                                </div>
                                <div class="mt-5 b-0">
                                    <button type="button" id="id-dialog-register" value="create" class="column-simple-view mt-2"
                                        onClick={() => { setActiveTab("v-pills-home"); setStep(0); }}>{props.t("Login.IDS_LBL_PREVIOUS")}</button>
                                    <button type="button" id="id-dialog-close" value="cancel create"
                                        class="textBtn btn_white_bg btn btn-secondary d-inline-block mt-2 float-right"
                                        onClick={() => {
                                            organisation && organisation !== "" && setActiveTab("v-pills-register");
                                            organisation && organisation !== "" && setStep(2);
                                        }}>{props.t("Login.IDS_LBL_CONTINUE")}</button>
                                </div>
                            </div>
                        </div>
                        <div className={`tab-pane ${activeTab === 'v-pills-register' ? 'active' : ''}`} id="v-pills-register" role="tabpanel" aria-labelledby="v-pills-register-tab">
                            <h5>{props.t("Login.IDS_LBL_REGISTER")}</h5>
                            <p>{props.t("Login.IDS_LBL_HELPINFO")} <a target="_blank" rel="noopener noreferrer"
                            href="https://helpcenter.agaramtech.com/">{props.t("Login.IDS_LBL_HELPPAGE")}</a></p>

                            <div class="form-group " onSubmit={handleSubmit}>
                                <div class={usernameError ? "input-group invalid" : "input-group"}>
                                    <div class="input-group-addon">
                                        <i class="user-icon"></i>
                                    </div>
                                    <input class="form-control" id="name" name="name" placeholder='Name' type="text" autocomplete="off"
                                        value={username}  onChange={handleUsernameChange} />
                                    {username &&
                                        (<>
                                            {usernameError ? (<i className="k-icon k-i-x invalid-icon"></i>) : (<i className="k-icon k-i-check valid-icon"></i>)}
                                        </>)}
                                </div>

                                <div class={ispasswordvalid ? "input-group invalid" : "input-group"}>
                                    <div class="input-group-addon">
                                        <i class="password-icon"></i>
                                    </div>
                                    <input minLength={5}  class="form-control" id="password" name="password" placeholder={props.t("Login.IDS_LBL_PASSWORD")} type="password" autocomplete="off"
                                        value={password}  onChange={onpasswordchange} />
                                    {password &&
                                        (<>
                                            {ispasswordvalid ? (<i className="k-icon k-i-x invalid-icon"></i>) : (<i className="k-icon k-i-check valid-icon"></i>)}
                                        </>)}
                                </div>
                                <div class={isconfirmpasswordvalid ? "input-group invalid" : "input-group"}>
                                    <div class="input-group-addon">
                                        <i class="password-icon"></i>
                                    </div>
                                    <input minLength={5} class="form-control" id="confirmpassword" name="confirmpassword" placeholder={props.t("Login.IDS_LBL_CONFIRMPASSWORD")}  type="password" autocomplete="off"
                                        value={confirmpassword}  onChange={onconfirmpasswordchange} />
                                    {confirmpassword &&
                                        (<>
                                            {isconfirmpasswordvalid ? (<i className="k-icon k-i-x invalid-icon"></i>) : (<i className="k-icon k-i-check valid-icon"></i>)}
                                        </>)}
                                </div>
                                
                                <div class={emailError ? "input-group invalid" : "input-group"}>
                                    <div class="input-group-addon">
                                        <i class="email-icon"></i>
                                    </div>
                                    <input class="form-control" id="email" name="email" placeholder='Email-Id' type="text" autocomplete="off"
                                        value={email} onChange={handleEmailChange} />
                                    {email && (<>{emailError ? (<i className="k-icon k-i-x invalid-icon"></i>) : (<i className="k-icon k-i-check valid-icon"></i>)}</>)}
                                </div>
                                {/* <div className='input-captcha'>
                                    <div className='input-group'>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter CAPTCHA text"
                                            value={userInput}
                                            onChange={handleUserInputChange}
                                        />
                                        <button className='btn_white_bg m-2 btn ' onClick={handleReloadCaptcha}><i className='fas fa-sync'></i></button>
                                    </div>
                                    <div className='captcha-text'>
                                        <span>{captchaText}</span>
                                         //<button className='btn_white_bg btn ml-2' onClick={handleCaptchaSubmit}>Submit</button>  
                                    </div>
                                    {captchaError && <p className='invalid-text mt-2'>{captchaError}</p>}
                                </div> */}
                                <button className='textBtn btn_white_bg m-2 btn btn-secondary' onClick={onuserlogin}>{props.t("Login.IDS_LBL_REGISTER")}</button>
                                <p className="text-center mt-3 mb-0 ortext">{props.t("Login.IDS_LBL_OR")}</p>
                                <div className="border-line mb-4 mt-1"><p className="text-center mt-3">{props.t("Login.IDS_LBL_REGISTEROPTIONS")} </p></div>

                                <ul className="list-inline text-center">
                                    <li className="list-inline-item"><Googlelogin callbackonsuccess={onthirdpartyautenticated} /></li>
                                    <li className="list-inline-item"><Microsoftlogin callbackonsuccess={onthirdpartyautenticated} /></li>

                                </ul>
                                <div class="mt-5 b-0">
                                    <button type="button" id="id-dialog-register" value="create" class="column-simple-view mt-2"
                                        onClick={() => { setActiveTab("v-pills-profile"); setStep(1); }}>{props.t("Login.IDS_LBL_PREVIOUS")}</button>
                                    {/* <button type="button" id="id-dialog-close" value="cancel create" class="textBtn btn_white_bg btn btn-secondary d-inline-block mt-2 float-right">Activate Free Plan</button> */}
                                </div>
                            </div>
                        </div>
                        <div className={`tab-pane text-center ${ activeTab === 'v-pills-messages' ? 'active' : ''}`} id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab">
                            <img src='../images/success_register.svg' alt='' />
                            <div className='mt-3'>
                                <h3>{props.t("Login.IDS_LBL_SUCCESSREGISTER")}</h3>
                                <p>{props.t("Login.IDS_LBL_TRIALINFO")} ({registereddate.getDate() + "/" + (registereddate.getMonth() + 1) + "/" + registereddate.getFullYear()}) {props.t("Login.IDS_LBL_EXPIRYDATE", {days : accountselect === 3 ? 90 : 30})} 
                                     {/* {autenticate_from === 1 || autenticate_from === 2 ? "" :props.t("Login.IDS_MSG_TRIALEMILMSG")} */}
                                    </p>
                            </div>
                            <NavLink className='textBtn btn_white_bg m-2 btn btn-primary-blue'
                                to={{
                                    pathname: "/",
                                    state: {},
                                }}
                            >{props.t("Login.IDS_LBL_LOGIN")}</NavLink>
                        </div>
                    </div>
                </div>
            </div>
            <PageLoader isloader={IsLoader} />                 
        </div>
    );
}

export default withAlert()(withTranslation(Register));